// 双选会
export const tabDataIndexFairsConfig = [
  {
    tabName: '宣讲会',
    key: 1,
    link: '/xuanjianghui?secLNav=1&headerNav=12&activeKey=1&rightNav=3',
    list: [],
    pathName: 'detailpreach',
    navData: ['宣讲会'],
  },
  {
    tabName: '双选会',
    key: 2,
    link: '/fairs?secLNav=1&headerNav=11&activeKey=2&rightNav=5',
    list: [],
    pathName: 'detailfair',
  },
  {
    tabName: '全国重点高校宣讲会',
    key: 3,
    link: '/secotherweb?secLNav=1&headerNav=10&activeKey=3&category=JIC015&rightNav=7',
    list: [],
    pathName: 'normaldetail',
    detailRightNav: 8,
  },
];

// 招聘信息
export const tabDataIndexNoticesConfig = [
  {
    tabName: '在线招聘',
    key: 1,
    link: '/zhaopinxinxi?headerNav=14&normal=true&secLNav=2&activeKey=1&rightNav=9',
    list: [],
    detailRightNav: 10,
  },
  {
    tabName: '高校教师',
    key: 2,
    link: '/secotherweb?headerNav=10&normal=false&secLNav=2&category=JIC001&activeKey=2&rightNav=11',
    list: [],
    pathName: 'normaldetail',
    detailRightNav: 12,
  },
  {
    tabName: '高校职员',
    key: 3,
    link: '/secotherweb?headerNav=10&normal=false&secLNav=2&category=JIC002&activeKey=3&rightNav=13',
    list: [],
    pathName: 'normaldetail',
    detailRightNav: 14,
  },
  {
    tabName: '高职高专教师',
    key: 4,
    link: '/secotherweb?headerNav=10&normal=false&secLNav=2&category=JIC003&activeKey=4&rightNav=15',
    list: [],
    pathName: 'normaldetail',
    detailRightNav: 16,
  },
  {
    tabName: '教育局招考',
    key: 5,
    link: '/secotherweb?headerNav=10&normal=false&secLNav=2&category=JIC004&activeKey=5&rightNav=17',
    pathName: 'normaldetail',
    list: [],
    detailRightNav: 18,
  },
  {
    tabName: '中小学教师',
    key: 6,
    link: '/secotherweb?headerNav=10&normal=false&secLNav=2&category=JIC005&activeKey=6&rightNav=19',
    pathName: 'normaldetail',
    list: [],
    detailRightNav: 20,
  },
  {
    tabName: '幼儿园教师',
    key: 7,
    link: '/secotherweb?headerNav=10&normal=false&secLNav=2&category=JIC006&activeKey=7&rightNav=21',
    pathName: 'normaldetail',
    list: [],
    detailRightNav: 22,
  },
];

// 单位
export const unitZhaopinTabData = [
  {
    tabName: '事业单位',
    key: 1,
    link: '/secotherweb?headerNav=10&secLNav=3&category=JIC007&activeKey=1&rightNav=23',
    pathName: 'normaldetail',
    list: [],
    detailRightNav: 24,
  },
  {
    tabName: '公务员',
    key: 2,
    link: '/secotherweb?headerNav=10&secLNav=3&category=JIC008&activeKey=2&rightNav=25',
    pathName: 'normaldetail',
    list: [],
    detailRightNav: 26,
  },
  {
    tabName: '选调生',
    key: 3,
    link: '/secotherweb?headerNav=10&secLNav=3&category=JIC009&activeKey=3&rightNav=27',
    pathName: 'normaldetail',
    list: [],
    detailRightNav: 28,
  },
  {
    tabName: '西部计划',
    key: 4,
    link: '/secotherweb?headerNav=10&secLNav=3&category=JIC010&activeKey=4&rightNav=29',
    pathName: 'normaldetail',
    list: [],
    detailRightNav: 30,
  },
  {
    tabName: '特岗教师',
    key: 5,
    link: '/secotherweb?headerNav=10&secLNav=3&category=JIC011&activeKey=5&rightNav=31',
    pathName: 'normaldetail',
    list: [],
    detailRightNav: 32,
  },
  {
    tabName: '应征入伍',
    key: 6,
    link: '/secotherweb?headerNav=10&secLNav=3&category=JIC012&activeKey=6&rightNav=33',
    pathName: 'normaldetail',
    list: [],
    detailRightNav: 34,
  },
  {
    tabName: '三支一扶',
    key: 7,
    link: '/secotherweb?headerNav=10&secLNav=3&category=JIC013&activeKey=7&rightNav=35',
    pathName: 'normaldetail',
    list: [],
    detailRightNav: 36,
  },
  {
    tabName: '国际组织实习',
    key: 8,
    link: '/secotherweb?headerNav=10&secLNav=3&category=JIC014&activeKey=8&rightNav=37',
    pathName: 'normaldetail',
    list: [],
    detailRightNav: 38,
  },
];

export const rightNavs = {
  1: '新闻公告',
  2: '新闻公告,新闻公告详情',
  3: '宣讲会',
  4: '宣讲会,宣讲会详情',
  5: '双选会',
  6: '双选会,双选会详情',
  7: '全国重点高校宣讲会',
  8: '全国重点高校宣讲会,详情',
  9: '在线招聘',
  10: '在线招聘,详情',
  11: '高校教师',
  12: '高校教师,详情',
  13: '高校职员',
  14: '高校职员,详情',
  15: '高职高专教师',
  16: '高职高专教师,详情',
  17: '教育局招考',
  18: '教育局招考,详情',
  19: '中小学教师',
  20: '中小学教师,详情',
  21: '幼儿园教师',
  22: '幼儿园教师,详情',
  23: '事业单位',
  24: '事业单位,详情',
  25: '公务员',
  26: '公务员,详情',
  27: '选调生',
  28: '选调生,详情',
  29: '西部计划',
  30: '西部计划,详情',
  31: '特岗教师',
  32: '特岗教师,详情',
  33: '应征入伍',
  34: '应征入伍,详情',
  35: '三支一扶',
  36: '三支一扶,详情',
  37: '国际组织实习',
  38: '国际组织实习,详情',

  101: '招聘职位',
  102: '招聘职位,招聘职位详情',
};
